export const content = {
  button: {
    label: "Find address",
  },

  postcode: {
    label: "Postcode",
    errors: {
      required: "Please enter your postcode",
      numeric: "Postcode must contain numbers only",
      exactLength: "Postcode must contain 4 digits",
    },
  },

  state: {
    label: "State",
    errors: {
      required: "Please enter your state",
    },
  },

  streetNumber: {
    label: "Street no.",
    errors: {
      required: "Please enter your street number",
      validStreetNumber:
        "Oops! Enter your street number - then you can use letters, numbers or dash",
    },
  },

  streetName: {
    label: "Street name",
    errors: {
      required: "Please enter your street name",
      nonNumeric: "Street name cannot contain numbers or special characters",
    },
  },

  city: {
    label: "City/Suburb",
    errors: {
      required: "Please enter your city/suburb",
      nonNumeric: "City/suburb cannot contain numbers or special characters",
    },
  },

  unitType: {
    label: "Unit type",
    errors: {
      required: "Unit type is required when unit no. is provided",
    },
  },

  unitNumber: {
    label: "Unit no.",
    errors: {
      required: "Unit no. is required when unit type is provided",
    },
  },
};
